import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const PipelinesRepoDynamicPipelinesPageLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./dynamic-pipelines'),
});

export default PipelinesRepoDynamicPipelinesPageLoadable;
